import {useMutation} from '@tanstack/react-query';
import {useRouter} from 'next/router';
import {useCallback, useEffect, useState} from 'react';
import {viewerMutationAdapter} from '../../adapter/viewerMutationAdapter';
import useEventListener from '../useEventListener.hook';
import {useInterval} from '../useInterval.hook';

export const LAST_PAGE_INTERVAL_MS = 5000;

/**
 * 스케쥴링을 통해 마지막 페이지를 저장합니다
 * 페이지를 SPA로 변경될때나 브라우저를 끌 때도 저장합니다
 */
export function ScheduledLastPageFetcher({
  seriesId,
  productId,
  rate,
  spineIndex,
  isDone,
}: {
  seriesId: number;
  productId: number;
  rate: number;
  spineIndex: number;
  isDone: boolean;
}) {
  const {mutateAsync: fetchLastPage} = useMutation(
    viewerMutationAdapter.lastPage()
  );
  const router = useRouter();
  const [lastSentLastPageInfo, setLastSentLastPageInfo] = useState({
    rate: -1,
    spineIndex: -1,
  });

  const send = useCallback(async () => {
    await fetchLastPage({
      input: {seriesId, productId, rate, spineIndex, isDone},
    });

    setLastSentLastPageInfo({rate, spineIndex});
  }, [fetchLastPage, isDone, productId, rate, seriesId, spineIndex]);
  useInterval(async () => {
    if (
      lastSentLastPageInfo.rate === rate &&
      lastSentLastPageInfo.spineIndex === spineIndex
    ) {
      return;
    }
    await send();
  }, LAST_PAGE_INTERVAL_MS);

  useEventListener('hashchange', send);
  useEventListener('unload', send);

  useEffect(() => {
    router.events.on('routeChangeStart', send);
    return () => {
      router.events.off('routeChangeStart', send);
    };
  }, [router, send]);

  return null;
}
